import request from '@/utils/request'

let Team_awardApi = {

  /*团队奖励列表*/
  list(data) {
    return request._post('/shop/plus.team_award.Index/index', data);
},
/*添加团队奖励*/
add(data) {
    return request._post('/shop/plus.team_award.Index/add', data);
},
/*修改团队奖励*/
edit(data) {
    return request._post('/shop/plus.team_award.Index/edit', data);
},
/*删除团队奖励*/
del(data) {
    return request._post('/shop/plus.team_award.Index/del', data);
},
/*团队奖励详情*/
detail(data) {
  return request._post('/shop/plus.team_award.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.team_award.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.team_award.Setting/getSetting', data, errorback);
    },
}
export default Team_awardApi;



// WEBPACK FOOTER //
// ./src/api/team_award.js